"use strict";
// Function to check if a probability parameter matches a market parameter,
Object.defineProperty(exports, "__esModule", { value: true });
exports.isParameterValueMatching = void 0;
const betweb_openapi_axios_1 = require("betweb-openapi-axios");
const strings_1 = require("../../strings");
// based on the type and value, according to specified operator rules.
const isParameterValueMatching = (probabilityParameter, marketParameter) => {
    if (probabilityParameter.type !== marketParameter.type) {
        return false;
    }
    switch (marketParameter.operator) {
        case betweb_openapi_axios_1.ParameterOperator.Equal:
            if ((0, strings_1.isNumeric)(probabilityParameter.value) &&
                (0, strings_1.isNumeric)(marketParameter.value)) {
                return +probabilityParameter.value === +marketParameter.value;
            }
            return probabilityParameter.value === marketParameter.value;
        case betweb_openapi_axios_1.ParameterOperator.LessThanOrEqual:
            if ((0, strings_1.isNumeric)(probabilityParameter.value) &&
                (0, strings_1.isNumeric)(marketParameter.value)) {
                return +probabilityParameter.value <= +marketParameter.value;
            }
            return probabilityParameter.value <= marketParameter.value;
        case betweb_openapi_axios_1.ParameterOperator.MoreThanOrEqual:
            if ((0, strings_1.isNumeric)(probabilityParameter.value) &&
                (0, strings_1.isNumeric)(marketParameter.value)) {
                return +probabilityParameter.value >= +marketParameter.value;
            }
            return probabilityParameter.value >= marketParameter.value;
        case betweb_openapi_axios_1.ParameterOperator.Unknown:
        default:
            return true;
    }
};
exports.isParameterValueMatching = isParameterValueMatching;
//# sourceMappingURL=isParameterValueMatching.js.map